import { render, staticRenderFns } from "./FormDichiarazione.vue?vue&type=template&id=58e17883&scoped=true&"
import script from "./FormDichiarazione.vue?vue&type=script&lang=js&"
export * from "./FormDichiarazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e17883",
  null
  
)

export default component.exports